<template>
    <div>
        <div class="mb-6">
            <p class="text-sm">Are you sure you want to send this invoice to the customer?</p>
            <div class="bg-muval-gray-5 mt-3 rounded-md p-3">
                <p class="text-muval-gray-1 text-sm">
                    <span class="font-medium">Customer email: </span>
                    <span v-if="customerEmail">{{ customerEmail }}</span>
                    <span
                        v-else
                        class="text-muval-error"
                        >No email address found</span
                    >
                </p>
            </div>
        </div>
        <div class="mt-4 flex flex-col justify-end gap-2 md:flex-row">
            <MuvalButton
                cancelBtn
                class="order-2 md:order-1"
                @click="closeModal"
            >
                Cancel
            </MuvalButton>
            <MuvalButton
                :loading="loading"
                :disabled="!customerEmail"
                class="order-1 md:order-2"
                @click="sendEmail"
            >
                Send invoice
            </MuvalButton>
        </div>
    </div>
</template>

<script setup>
import MuvalButton from '@buttons/MuvalButton.vue';
import { toast } from 'vue-sonner';

const props = defineProps({
    invoiceId: {
        type: Number,
        required: true,
    },
    customerEmail: {
        type: String,
        required: true,
    },
});

const emit = defineEmits(['close:modal', 'email:sent']);
const order = useOrderStore();
const loading = ref(false);

async function sendEmail() {
    loading.value = true;

    try {
        const url = `/orders/${order.getOrderId}/invoices/${props.invoiceId}/send-email`;
        const response = await window.tenantAxios.post(url);

        if (response) {
            toast.success(response.data.message || 'Invoice email sent to customer successfully');
            emit('email:sent');
        }
    } catch (error) {
        // The interceptor rejects with processError()'s result: a 422 carries the API's reason, which it doesn't toast.
        const errorMessage = (error?.code === 422 && error.message) || 'Failed to send invoice email';
        toast.error(errorMessage);
    } finally {
        loading.value = false;
        closeModal();
    }
}

function closeModal() {
    emit('close:modal');
}
</script>
